<template>
	<v-container class="mt-4 ml-2" fluid>
	  <v-row v-if="acceso">
	  	<v-col cols="12">
	  		<v-card class="shadowCard">
	  		  <v-card-title primary-title>
	  		    <span class="text-subtitle-1">Retroalimentación de seguimiento</span>
	  		    <v-spacer></v-spacer>

            <v-btn
              class="mr-2"
              small dark color="green"
              @click="exportExcel( retros  , 'retros_ERP')"
              tile
            >
              <v-icon small>mdi-microsoft-excel</v-icon>
            </v-btn>

            <v-btn
              color="orange"
              dark
              class="mr-2"
              @click="dialog = true"
              small
              tile
            >
              <v-icon left small>mdi-plus</v-icon>
              Agregar
            </v-btn>

            <v-btn
              color="primary"
              dark
              class="text-capitalize"
              @click="initialize()"
              small
              tile
            >
              <v-icon left small>mdi-refresh</v-icon>
              Actualizar
            </v-btn>

	  		  </v-card-title>
	  		  <v-card-text>
	  		  	<v-row justify="space-between">

	  		  		<v-col cols="12" md="4" lg="3">
	  		  			<label>Selecciona el ciclo</label>
                <v-autocomplete
                  filled
                  dense
                  clearable
                  v-model="ciclo"
                  :items="ciclos"
                  label="Selecciona ciclo actual"
                  persistent-hint
                  hide-details
                  return-object
                  item-text="ciclo"
                  item-value="id_ciclo"
                  single-line
                >
                </v-autocomplete>
	  		  		</v-col>

	  		  		<v-col cols="12" md="4" lg="3">
	  		  			<label>Fecha incio</label>
	              <v-text-field
                  label="Fecha de incio"
                  filled
                  dense
                  v-model="fechaini"
                  single-line
                  type="date"
                ></v-text-field>
	  		  		</v-col>

	  		  		<v-col cols="12" md="4" lg="3">
	  		  			<label>Fecha final</label>
	              <v-text-field
                  label="Fecha de incio"
                  filled
                  dense
                  v-model="fechafin"
                  single-line
                  type="date"
                ></v-text-field>
	  		  		</v-col>

	  		  		<v-col cols="12" md="4" lg="3">
	  		  			<label>Selecciona el concepto</label>
	              <v-select
                  :items="[{id: 1, concepto: 'NI'},{id: 2, concepto: 'RI'},{id: 3, concepto: 'TODOS'}]"
                  v-model="concepto"
                  label="Concepto"
                  item-text="concepto"
                  item-value="id"
                  filled
                  dense
                  single-line
                ></v-select>
	  		  		</v-col>

	  		  		<v-col cols="12" md="4" lg="3">
	  		  			<label>Selecciona el estatus</label>
	              <v-select
                  :items="[{id: 0, concepto: 'Asignado'},{id: 1, concepto: 'Aceptado'},{id: 2, concepto: 'Rechazado'},{id: 3, concepto: 'Todos'}]"
                  v-model="estatus"
                  label="estatus"
                  item-text="concepto"
                  item-value="id"
                  filled
                  dense
                  single-line
                ></v-select>
	  		  		</v-col>

	  		  		<v-col cols="12" md="4" lg="3">
	  		  			<label>Selecciona el usuario</label>
	              <v-autocomplete
                  :items="evaluados"
                  v-model="evaluado"
                  label="Evaluado"
                  item-text="evaluado"
                  item-value="id_evaluado"
                  filled
                  dense
                  single-line
                  clearable
                ></v-autocomplete>
	  		  		</v-col>

              <v-col cols="12" md="4" lg="3">
	  		  			<label>Selecciona el plantel</label>
	              <v-autocomplete
                  :items="planteles"
                  v-model="plantel"
                  label="Plantel"
                  item-text="plantel"
                  item-value="id_plantel"
                  filled
                  dense
                  single-line
                  clearable
                ></v-autocomplete>
	  		  		</v-col>

	  		  		<v-col cols="12" md="4" lg="3">
	  		  			<v-text-field
	  		  			  name="name"
	  		  			  label="Buscar"
	  		  			  id="id"
	  		  			  filled
	  		  			  dense
	  		  			  hide-details
	  		  			  append-icon="mdi-magnify"
	  		  			  v-model="search"
	  		  			></v-text-field>
	  		  		</v-col>
	  		  	</v-row>

	  		  	<label>Reporte</label>
	  		  	<v-row>
	  		    	<v-col cols="12">
							  <v-data-table
							    :headers="headersReporte"
							    :items="reporte"
							    class="elevation-0"
							    :mobile-breakpoint="100"
			            dense
			            :items-per-page="10"
			            hide-default-footer
							  >
							    <template v-slot:no-data>
							      <v-btn
							        color="primary"
							        @click="initialize"
							        small
							      >
							        Actualizar
							      </v-btn>
							    </template>

							  </v-data-table>
	  		    	</v-col>
	  		    </v-row>

	  		    <v-row>
	  		    	<v-col cols="12">
							  <v-data-table
							    :headers="headers"
							    :items="filterRetros"
							    class="elevation-0"
							    :search="search"
							    :mobile-breakpoint="100"
			            dense
							  >
							    <!-- Valores que ocupan botons, chips, iconos, etc -->
							    <template v-slot:item.estatus="{ item }">
							      <v-chip
							      	v-if="item.estatus == 1"
							      	small
							      	color="green"
							      	dark
							      >Aceptado</v-chip>

							      <v-chip
							      	v-if="item.estatus == 2"
							      	small
							      	color="black"
							      	dark
							      >Rechazado</v-chip>

							      <v-chip
							      	v-if="item.estatus == 0 && item.validado == 1"
							      	small
							      	color="blue"
							      	dark
							      >Asignado</v-chip>

							      <v-chip
							      	v-if="item.estatus == 0 && item.validado == 0"
							      	small
							      	color="grey"
							      	dark
							      >Por validar</v-chip>

							    </template>

							    <template v-slot:item.concepto="{ item }">
							      <v-chip
							      	v-if="item.concepto == 1"
							      	small
							      	color="grey"
							      	dark
							      >NI</v-chip>

							      <v-chip
							      	v-if="item.concepto == 2"
							      	small
							      	color="orange"
							      	dark
							      >RI</v-chip>

							    </template>


							    <template v-slot:item.actions="{ item }">
							    	<v-btn
							    		color="primary"
							    		x-small
							    		@click="editItem(item)"
							    		class="mr-2"
							    	>
								      <v-icon small>mdi-magnify</v-icon>
							    	</v-btn>

							    	<v-btn
							    		color="error"
							    		x-small
							    		@click="deleteItem(item)"
							    		v-if="getdatosUsuarioERPERP.iderp == item.id_evalua"
							    		class="mr-2"
							    	>
								      <v-icon small> mdi-delete</v-icon>
							    	</v-btn>
							    </template>

							    <template v-slot:no-data>
							      <v-btn
							        color="primary"
							        @click="initialize"
							        small
							      >
							        Actualizar
							      </v-btn>
							    </template>

							  </v-data-table>
	  		    	</v-col>
	  		    </v-row>
	  		  </v-card-text>
	  		</v-card>
	  	</v-col>
	  </v-row>

	  <!-- Dialogo de editar o agregar-->
	  <v-dialog
      v-model="dialog"
      max-width="800px"
      persistent
      @keydown.ctrl="pegar"
    >
      <v-card>
        <v-card-title>
          <span class="text-subtitle-1">{{ formTitle }}</span>
          <v-spacer></v-spacer>
          <span class="text-subtitle-1">
          	<strong>ID: {{ editedItem.idretroalimentacion }}</strong>
          </span>
        </v-card-title>

        <v-card-text>
          <v-row>
          	<v-col cols="12">
          		<label>Selecciona el concepto</label><br/>
	  		  		<label>Elige la opción que deseas evaluar si es un NI o es un RI</label>
              <v-radio-group
					      v-model="editedItem.concepto"
					      row
					      hide-details
					    >
					      <v-radio
					        label="NI"
					        :value="1"
					      ></v-radio>
					      <v-radio
					        label="RI"
					        :value="2"
					      ></v-radio>
					    </v-radio-group>
            </v-col>

            <v-col v-if="editedItem.concepto===2" cols="12">
          		<label>Selecciona el plantel a evaluar</label><br/>
	  		  		<label>Selecciona el plantel que deseas evaluar y deberá ser responsable de los seguimiento de: {{ editedItem.concepto == 1 ? 'NI' : editedItem.concepto == 2 ? 'RI' : '' }}</label>
	  		  		<v-autocomplete
	  		  			filled
	  		  			dense
	  		  			clearable
	  		  			v-model="editedItem.id_plantel"
	  		  			:items="planteles"
								label="Selecciona un plantel"
								hide-details
								item-text="plantel"
								item-value="id_plantel"
								:readonly="editedIndex >= 0 ? true : false"
							>
							</v-autocomplete>
            </v-col>

            <v-col v-if="editedItem.concepto===1" cols="12">
          		<label>Selecciona el usuario a evaluar</label><br/>
	  		  		<label>Selecciona la persona que deseas evaluar y deberá ser responsable de los seguimiento de: {{ editedItem.concepto == 1 ? 'NI' : editedItem.concepto == 2 ? 'RI' : '' }}</label>
	  		  		<v-autocomplete
	  		  			filled
	  		  			dense
	  		  			clearable
	  		  			v-model="editedItem.id_usuario"
	  		  			:items="usuarios"
								label="Selecciona un usuario"
								hide-details
								item-text="datos_completos"
								item-value="id_usuario"
								:readonly="editedIndex >= 0 ? true : false"
							>
							</v-autocomplete>
            </v-col>

            <v-col cols="12" v-if="editedItem.concepto">
							<v-card class="shadowCard">
								<v-card-title class="text-subtitle-1">Bandeja de entrada de WhatsApp</v-card-title>
							  <v-card-text class="black--text">
							    <v-row>

										<v-col cols="12" md="6" class="mb-4">
          						<label class="grey--text darken-5">Toma una captura de pantalla de la bandeja de entrada y presiona Ctrl + V en este recuadro para pegarla.</label>
						          <v-file-input
										    label="Da clic para agregar una imagen"
										    filled
										    prepend-icon="mdi-camera"
										    v-model="editedItem.file"
										    @change="updateFoto2( )"
										  ></v-file-input>

						          <v-img :src="editedItem.url" v-if="editedItem.url" contain max-height="300"/>

						          <v-btn
						          	v-if="editedItem.file"
						          	color="red"
						          	dark
						          	small
						          	tile
						          	@click="editedItem.file = null, editedItem.url = null"
						          	class="mt-4"
						          >
						          	<v-icon small left>mdi-delete</v-icon>
						        		Eliminar
						        	</v-btn>

										</v-col>

										<v-col cols="12" md="6">
          						<label class="grey--text darken-5">A continuación, solo elige la opción que mejor corresponda entre un SI y un NO.</label>
          						<br/>
          						<br/>
											<label >
												¿Cuenta con mensajes sin leer de <b>más de una hora?</b>
											</label>
											<v-radio-group
									      v-model="editedItem.p1"
									      row
									      dense
									      hide-details
									      class="mb-2 mt-0"
									    >
									      <v-radio
									      	class="pt-0"
									        label="SI"
									        :value="1"
									      ></v-radio>
									      <v-radio
									      	class="pt-0"
									        label="NO"
									        :value="2"
									      ></v-radio>
									    </v-radio-group>

											<label >
												¿Cuenta con {{ editedItem.concepto == 1 ? 'prospectos' : 'alumnos' }} <b>en visto?</b>
											</label>
									    <v-radio-group
									      v-model="editedItem.p2"
									      row
									      dense
									      hide-details
									      class="pt-0 mt-0"
									    >
									      <v-radio
									        label="SI"
									        :value="1"
									      ></v-radio>
									      <v-radio
									        label="NO"
									        :value="2"
									      ></v-radio>
									    </v-radio-group>

											<v-textarea
												v-model="editedItem.p3"
												:rows="6"
												auto-grow
												filled
												dense
												label="Escribe una Retroalimentación"
											>
											</v-textarea>
										</v-col>
							    </v-row>
							  </v-card-text>
							</v-card>
						</v-col>

						<v-col cols="12" v-for="(contacto , i ) in contactos" :key="i" v-if="editedItem.concepto">
							<v-card class="shadowCard" :class="{'grey lighten-4': !puedeEditarContactos}">
								<v-card-title class="text-subtitle-1">Contacto #{{ i + 1 }}</v-card-title>
							  <v-card-text>
							    <v-row>
				            <v-col cols="12">
	  		  						<label v-if="editedItem.concepto == 1">Elige el prospecto del cual vas a evaluar la información </label>
											<v-autocomplete
												 v-if="editedItem.concepto == 1"
							          filled
							          dense
							          clearable
							          v-model="contacto.idprospectos"
							          :items="prospectos"
							          label="Selecciona el Prospecto"
							          hide-details
							          item-text="datos_completos"
							          item-value="idprospectos"
                           :disabled="!puedeEditarContactos"
                           @change="onCambioProspecto(contacto)"
							          class="mt-4"
							        >
							        </v-autocomplete>

							        <label v-if="editedItem.concepto == 2">Selecciona el alumno del cual revisarás el seguimiento</label>
											<v-autocomplete
												v-if="editedItem.concepto == 2"
							          filled
							          dense
							          clearable
							          v-model="contacto.id_alumno"
							          :items="alumnos"
							          label="Selecciona el alumno"
							          item-text="datos_completos"
							          item-value="id_alumno"
                             :disabled="!puedeEditarContactos"
							          class="mt-4"
							        >
							        </v-autocomplete>

							        <label v-if="editedItem.concepto == 2">Ingresa el número de teléfono con el que se hizo el seguimiento </label>
											<v-text-field
												v-if="editedItem.concepto == 2"
											  filled
											  v-model="contacto.telefono"
											  dense
											  label="Teléfono"
											  hide-details
                         :disabled="!puedeEditarContactos"
											></v-text-field>
										</v-col>

										<v-col cols="12" md="6" class="mb-4">
          						<label class="grey--text darken-5">Toma una captura de pantalla de la bandeja de entrada y presiona Ctrl + V en este recuadro para pegarla.</label>
						          <v-file-input
										    label="File input"
										    filled
										    prepend-icon="mdi-camera"
										    v-model="contacto.file"
										    @change="updateFoto( contacto )"
                       :disabled="!puedeEditarContactos"
										  ></v-file-input>

						          <v-img :src="contacto.url" v-if="contacto.file" contain max-height="300"/>

						          <v-btn
						          	v-if="contacto.file"
						          	color="red"
						          	dark
						          	small
						          	tile
						          	@click="contacto.file = null, contacto.url = null"
						          	class="mt-4"
                           :disabled="!puedeEditarContactos"
						          >
						          	<v-icon small left>mdi-delete</v-icon>
						        		Eliminar
						        	</v-btn>
										</v-col>

										<v-col cols="12" md="6">
          						<label class="grey--text darken-5">A continuación, solo elige la opción que mejor corresponda entre un SI y un NO.</label><br/>
											<label v-if="editedItem.concepto == 1">¿Hay mensajes Robotizados?</label>
											<v-radio-group
												v-if="editedItem.concepto == 1"
									      v-model="contacto.valor1"
									      row
									      dense
									      hide-details
									      class="mt-0 mb-4"
                         :disabled="!puedeEditarContactos"
									    >
									      <v-radio
									        label="SI"
									        :value="1"
									      ></v-radio>
									      <v-radio
									        label="NO"
									        :value="2"
									      ></v-radio>
									    </v-radio-group>

											<label v-if="editedItem.concepto == 1">¿El tiempo de respuesta entre el cliente y el asesor es adecuado?</label>
									    <v-radio-group
												v-if="editedItem.concepto == 1"
									      v-model="contacto.valor2"
									      row
									      dense
									      hide-details
									      class="mt-0 mb-4"
                         :disabled="!puedeEditarContactos"
									    >
									      <v-radio
									        label="SI"
									        :value="1"
									      ></v-radio>
									      <v-radio
									        label="NO"
									        :value="2"
									      ></v-radio>
									    </v-radio-group>

											<label v-if="editedItem.concepto == 1">¿El asesor usa herramientas adicionales en su seguimiento como audios e imágenes?</label>
									    <v-radio-group
												v-if="editedItem.concepto == 1"
									      v-model="contacto.valor3"
									      row
									      dense
									      hide-details
									      class="mt-0 mb-4"
                         :disabled="!puedeEditarContactos"
									    >
									      <v-radio
									        label="SI"
									        :value="1"
									      ></v-radio>
									      <v-radio
									        label="NO"
									        :value="2"
									      ></v-radio>
									    </v-radio-group>

											<label v-if="editedItem.concepto == 1">¿El asesor usa los documentos de la escuela de manera correcta (Plan de estudios, calendarios de pago , métodos de pago)?</label>
									    <v-radio-group
												v-if="editedItem.concepto == 1"
									      v-model="contacto.valor4"
									      row
									      dense
									      hide-details
									      class="mt-0 mb-4"
                         :disabled="!puedeEditarContactos"
									    >
									      <v-radio
									        label="SI"
									        :value="1"
									      ></v-radio>
									      <v-radio
									        label="NO"
									        :value="2"
									      ></v-radio>
									    </v-radio-group>

											<label v-if="editedItem.concepto == 1">¿El asesor se dirige con formalidad al prospecto?</label>
									    <v-radio-group
												v-if="editedItem.concepto == 1"
									      v-model="contacto.valor5"
									      row
									      dense
									      hide-details
									      class="mt-0 mb-4"
                         :disabled="!puedeEditarContactos"
									    >
									      <v-radio
									        label="SI"
									        :value="1"
									      ></v-radio>
									      <v-radio
									        label="NO"
									        :value="2"
									      ></v-radio>
									    </v-radio-group>

											<label v-if="editedItem.concepto == 2">¿Hay seguimientos Robotizados?</label>
									    <v-radio-group
												v-if="editedItem.concepto == 2"
									      v-model="contacto.valor6"
									      row
									      dense
									      hide-details
									      class="mt-0 mb-4"
                         :disabled="!puedeEditarContactos"
									    >
									      <v-radio
									        label="SI"
									        :value="1"
									      ></v-radio>
									      <v-radio
									        label="NO"
									        :value="2"
									      ></v-radio>
									    </v-radio-group>

											<label v-if="editedItem.concepto == 2">¿El tiempo de respuesta entre el alumno y el asesor académico es adecuado? </label>
									    <v-radio-group
												v-if="editedItem.concepto == 2"
									      v-model="contacto.valor7"
									      row
									      dense
									      hide-details
									      class="mt-0 mb-4"
                         :disabled="!puedeEditarContactos"
									    >
									      <v-radio
									        label="SI"
									        :value="1"
									      ></v-radio>
									      <v-radio
									        label="NO"
									        :value="2"
									      ></v-radio>
									    </v-radio-group>

											<label v-if="editedItem.concepto == 2">¿El asesor resuelve las situaciones y dudas del alumno?</label>
									    <v-radio-group
												v-if="editedItem.concepto == 2"
									      v-model="contacto.valor8"
									      row
									      dense
									      hide-details
									      class="mt-0 mb-4"
                         :disabled="!puedeEditarContactos"
									    >
									      <v-radio
									        label="SI"
									        :value="1"
									      ></v-radio>
									      <v-radio
									        label="NO"
									        :value="2"
									      ></v-radio>
									    </v-radio-group>

											<label v-if="editedItem.concepto == 2">¿El asesor envia el recordatorio de pago en tiempo y forma?</label>
									    <v-radio-group
												v-if="editedItem.concepto == 2"
									      v-model="contacto.valor9"
									      row
									      dense
									      hide-details
									      class="mt-0 mb-4"
                         :disabled="!puedeEditarContactos"
									    >
									      <v-radio
									        label="SI"
									        :value="1"
									      ></v-radio>
									      <v-radio
									        label="NO"
									        :value="2"
									      ></v-radio>
									    </v-radio-group>

											<label v-if="editedItem.concepto == 2">¿El asesor se dijere de manera formal y educada con el alumno?</label>
									    <v-radio-group
												v-if="editedItem.concepto == 2"
									      v-model="contacto.valor10"
									      row
									      dense
									      hide-details
									      class="mt-0 mb-4"
                         :disabled="!puedeEditarContactos"
									    >
									      <v-radio
									        label="SI"
									        :value="1"
									      ></v-radio>
									      <v-radio
									        label="NO"
									        :value="2"
									      ></v-radio>
									    </v-radio-group>

											<v-textarea
												v-model="contacto.retroalimentacion"
												:rows="6"
												auto-grow
												filled
												dense
												label="Escribe una Retroalimentación"
                         :disabled="!puedeEditarContactos"
											>
											</v-textarea>
										</v-col>

                    <v-col cols="12">
                      <v-divider class="my-2"></v-divider>
                      <div class="d-flex align-center justify-space-between">
                        <div>
                          <div class="font-weight-medium">Audio del chat seleccionado</div>
                          <div v-if="contacto.audio_numero">
                            Audio #{{ contacto.audio_numero }}
                          </div>
                          <div v-else class="grey--text text--darken-1">
                            Ningún audio seleccionado aún.
                          </div>
                        </div>
                        <div>
							<v-btn
                            color="primary"
                            small
                            tile
                            class="mr-2"
                            @click="subirAudio(contacto, i)"
                            :disabled="!puedeEditarContactos || (editedItem.concepto == 1 ? !contacto.idprospectos : !contacto.id_alumno)"
                          >
                            <v-icon left small>mdi-music</v-icon>
                            Subir audio
                          </v-btn>
                          <v-btn
                            color="primary"
                            small
                            tile
                            class="mr-2"
                            @click="abrirSelectorAudio(contacto, i)"
                            :disabled="!puedeEditarContactos || (editedItem.concepto == 1 ? !contacto.idprospectos : !contacto.id_alumno)"
                          >
                            <v-icon left small>mdi-music</v-icon>
                            Seleccionar audio
                          </v-btn>
                          <v-btn
                            v-if="contacto.audio_url"
                            color="red"
                            small
                            tile
                            outlined
                            @click="confirmarQuitarAudio(contacto)"
                          >
                            <v-icon left small>mdi-delete</v-icon>
                            Quitar audio
                          </v-btn>
                        </div>
                      </div>

                      <div v-if="contacto.audio_url" class="mt-2">
                        <audio
                          :src="contacto.audio_url"
                          controls
                          style="width: 100%;"
                        ></audio>
                      </div>

                      <v-textarea
                        v-model="contacto.audio_comentario"
                        :rows="3"
                        auto-grow
                        filled
                        dense
                        class="mt-2"
                        label="Comentario para el audio seleccionado"
                        :disabled="!puedeEditarContactos || !contacto.audio_url"
                      >
                      </v-textarea>
                    </v-col>
							    </v-row>
							  </v-card-text>
							</v-card>
						</v-col>

          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="black"
            tile
            dark
            small
            @click="close"
          >
            <v-icon small left>mdi-cancel</v-icon>
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            class=""
            tile
            dark
            small
            @click="save"
          >
            <v-icon small left>mdi-content-save</v-icon>
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Selector de audio por contacto -->
    <v-dialog
      v-model="dialogAudios.estatus"
      max-width="600px"
      persistent
    >
      <v-card>
        <v-card-title class="text-subtitle-1">
          Seleccionar audio del chat
        </v-card-title>
        <v-card-text>
          <div v-if="dialogAudios.index !== null">
            <div
              v-if="contactos[dialogAudios.index].audios_disponibles && contactos[dialogAudios.index].audios_disponibles.length"
            >
              <v-list dense>
                <v-list-item
                  v-for="audio in contactos[dialogAudios.index].audios_disponibles"
                  :key="audio.id"
                  @click="seleccionarAudio(audio)"
                >
                  <v-list-item-content>
                    <div class="font-weight-medium">
                      Audio #{{ audio.numero }}
                      <span class="grey--text text--darken-1">— {{ audio.fecha }}</span>
                    </div>
                    <audio
                      :src="audio.url"
                      controls
                      style="width: 100%; margin-top: 4px;"
                    ></audio>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-icon>mdi-check-circle-outline</v-icon>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </div>
            <v-alert v-else type="warning" dense>
              No se encontraron audios en el chat de este contacto.
            </v-alert>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small text @click="dialogAudios.estatus = false">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogEdit"
      max-width="800px"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-subtitle-1">{{ formTitle }}</span>
          <v-spacer></v-spacer>
          <span class="text-subtitle-1">
          	<strong>ID: {{ editedItem.id_plantel }}</strong>
          </span>
        </v-card-title>

        <v-card-text>
          <v-row>
          	<v-col cols="12">
          		<label>Selecciona el concepto</label>
              <v-radio-group
					      v-model="contacto.concepto"
					      row
					      hide-details
					      readonly
					    >
					      <v-radio
					        label="NI"
					        :value="1"
					      ></v-radio>
					      <v-radio
					        label="RI"
					        :value="2"
					      ></v-radio>
					    </v-radio-group>

                      <v-divider class="my-2" v-if="folios"></v-divider>

                      <div v-if="folios">
                        <div class="font-weight-medium">Audio del chat seleccionado</div>
                        <div v-if="folios.audio_numero">
                          Audio #{{ folios.audio_numero }}
                        </div>
                        <div v-else class="grey--text text--darken-1">
                          Sin audio seleccionado.
                        </div>

                        <div v-if="folios.audio_url" class="mt-2">
                          <audio
                            :src="folios.audio_url"
                            controls
                            style="width: 100%;"
                          ></audio>
                        </div>

                        <v-textarea
                          v-if="folios.audio_comentario"
                          v-model="folios.audio_comentario"
                          :rows="3"
                          auto-grow
                          filled
                          dense
                          class="mt-2"
                          label="Comentario del audio"
                          readonly
                        >
                        </v-textarea>
                      </div>
            </v-col>

            <v-col cols="12">
          		<label>Evaluó: </label><br/>
	  		  		<b>{{ contacto.evalua }}</b>
	  		  		<br/>
	  		  		<br/>

	  		  		<label>Evaluado: </label><br/>
	  		  		<b>{{ contacto.evaluado }}</b>
	  		  		<br/>
	  		  		<br/>

	  		  		<label>Promedio: </label><br/>
              <b>{{ contacto.promedio }}</b>
              <br/>
              <br/>

              <label>Estatus: </label><br/>
              <v-chip v-if="contacto.estatus == 0" small dark color="blue">Asignado</v-chip>
              <v-chip v-if="contacto.estatus == 1" small dark color="green">Aceptado</v-chip>
              <v-chip v-if="contacto.estatus == 2" small dark color="black">Rechazado</v-chip>
              <br/>
              <br/>

              <label>Mensaje Rechazo: </label><br/>
              <b>{{ contacto.mensaje_rechazo }}</b>
              <br/>
              <br/>
            </v-col>

            <v-col cols="12">
							<v-card class="shadowCard">
								<v-card-title class="text-subtitle-1">Bandeja de entrada de WhatsApp</v-card-title>
							  <v-card-text class="black--text">
							    <v-row>

										<v-col cols="12" md="6" class="mb-4">
						          <v-img :src="url + contacto.foto" contain max-height="300"/>
										</v-col>

										<v-col cols="12" md="6">
          						<label class="grey--text darken-5">A continuación, solo elige la opción que mejor corresponda entre un SI y un NO.</label>
          						<br/>
          						<br/>
											<label v-if="contacto.concepto == 1">
												¿Cuenta con mensajes sin leer de <b>más de una hora?</b>
											</label>
											<v-radio-group
												v-if="contacto.concepto == 1"
									      v-model="contacto.p1"
									      row
									      dense
									      hide-details
					     				  readonly
									      class="mb-2 mt-0"
									    >
									      <v-radio
									      	class="pt-0"
									        label="SI"
									        :value="1"
									      ></v-radio>
									      <v-radio
									      	class="pt-0"
									        label="NO"
									        :value="2"
									      ></v-radio>
									    </v-radio-group>

											<label v-if="contacto.concepto == 1">
												¿Cuenta con {{ contacto.concepto == 1 ? 'prospectos' : 'alumnos' }} <b>en visto?</b>
											</label>
									    <v-radio-group
												v-if="contacto.concepto == 1"
									      v-model="contacto.p2"
									      row
									      dense
									      readonly
									      hide-details
									      class="pt-0 mt-0"
									    >
									      <v-radio
									        label="SI"
									        :value="1"
									      ></v-radio>
									      <v-radio
									        label="NO"
									        :value="2"
									      ></v-radio>
									    </v-radio-group>

											<v-textarea
												v-model="contacto.p3"
												:rows="6"
												auto-grow
												filled
												dense
												readonly
												label="Escribe una Retroalimentación"
											>
											</v-textarea>
										</v-col>
							    </v-row>
							  </v-card-text>
							</v-card>
						</v-col>

						<v-col cols="12" v-for="(folios , i ) in contacto.contactos" :key="i">
							<v-card class="shadowCard">
								<v-card-title class="text-subtitle-1">Contacto #{{ i + 1 }}</v-card-title>
							  <v-card-text>
							    <v-row>
				            <v-col cols="12">
											<div v-if="contacto.concepto == 1"><b>Folio:</b> {{ folios.folio }}</div><br/>
											<div v-if="contacto.concepto == 2"><b>Alumno:</b> {{ folios.alumno }}</div><br/>
											<b>Telefono:</b> {{ folios.telefono }}<br/>
										</v-col>

										<v-col cols="12" md="6" class="mb-4">
						          <v-img :src="url + folios.foto" contain aspect-ratio="2" @click="verImagen( folios.foto )" />
										</v-col>


										<v-col cols="12" md="6">
											<label v-if="contacto.concepto == 1">¿Hay mensajes Robotizados?</label>
											<v-radio-group
												v-if="contacto.concepto == 1"
									      v-model="folios.valor1"
									      row
									      dense
									      hide-details
									      readonly
									      class="mt-0 mb-4"
									    >
									      <v-radio
									        label="SI"
									        :value="1"
									      ></v-radio>
									      <v-radio
									        label="NO"
									        :value="2"
									      ></v-radio>
									    </v-radio-group>

											<label v-if="contacto.concepto == 1">¿El tiempo de respuesta entre el cliente y el asesor es adecuado?</label>
									    <v-radio-group
												v-if="contacto.concepto == 1"
									      v-model="folios.valor2"
									      row
									      dense
									      readonly
									      hide-details
									      class="mt-0 mb-4"
									    >
									      <v-radio
									        label="SI"
									        :value="1"
									      ></v-radio>
									      <v-radio
									        label="NO"
									        :value="2"
									      ></v-radio>
									    </v-radio-group>

											<label v-if="contacto.concepto == 1">¿El asesor usa herramientas adicionales en su seguimiento como audios e imágenes?</label>
									    <v-radio-group
												v-if="contacto.concepto == 1"
									      v-model="folios.valor3"
									      row
									      dense
									      hide-details
									      readonly
									      class="mt-0 mb-4"
									    >
									      <v-radio
									        label="SI"
									        :value="1"
									      ></v-radio>
									      <v-radio
									        label="NO"
									        :value="2"
									      ></v-radio>
									    </v-radio-group>

											<label v-if="contacto.concepto == 1">¿El asesor usa los documentos de la escuela de manera correcta (Plan de estudios, calendarios de pago , métodos de pago)?</label>
									    <v-radio-group
												v-if="contacto.concepto == 1"
									      v-model="folios.valor4"
									      row
									      dense
									      hide-details
									      readonly
									      class="mt-0 mb-4"
									    >
									      <v-radio
									        label="SI"
									        :value="1"
									      ></v-radio>
									      <v-radio
									        label="NO"
									        :value="2"
									      ></v-radio>
									    </v-radio-group>

											<label v-if="contacto.concepto == 1">¿El asesor se dirige con formalidad al prospecto?</label>
									    <v-radio-group
												v-if="contacto.concepto == 1"
									      v-model="folios.valor5"
									      row
									      dense
									      hide-details
									      readonly
									      class="mt-0 mb-4"
									    >
									      <v-radio
									        label="SI"
									        :value="1"
									      ></v-radio>
									      <v-radio
									        label="NO"
									        :value="2"
									      ></v-radio>
									    </v-radio-group>

											<label v-if="contacto.concepto == 2">¿Hay seguimientos Robotizados?</label>
									    <v-radio-group
												v-if="contacto.concepto == 2"
									      v-model="folios.valor6"
									      row
									      dense
									      hide-details
									      readonly
									      class="mt-0 mb-4"
									    >
									      <v-radio
									        label="SI"
									        :value="1"
									      ></v-radio>
									      <v-radio
									        label="NO"
									        :value="2"
									      ></v-radio>
									    </v-radio-group>

											<label v-if="contacto.concepto == 2">¿El tiempo de respuesta entre el alumno y el asesor académico es adecuado? </label>
									    <v-radio-group
												v-if="contacto.concepto == 2"
									      v-model="folios.valor7"
									      row
									      dense
									      readonly
									      hide-details
									      class="mt-0 mb-4"
									    >
									      <v-radio
									        label="SI"
									        :value="1"
									      ></v-radio>
									      <v-radio
									        label="NO"
									        :value="2"
									      ></v-radio>
									    </v-radio-group>

											<label v-if="contacto.concepto == 2">¿El asesor resuelve las situaciones y dudas del alumno?</label>
									    <v-radio-group
												v-if="contacto.concepto == 2"
									      v-model="folios.valor8"
									      row
									      dense
									      readonly
									      hide-details
									      class="mt-0 mb-4"
									    >
									      <v-radio
									        label="SI"
									        :value="1"
									      ></v-radio>
									      <v-radio
									        label="NO"
									        :value="2"
									      ></v-radio>
									    </v-radio-group>

											<label v-if="contacto.concepto == 2">¿El asesor envia el recordatorio de pago en tiempo y forma?</label>
									    <v-radio-group
												v-if="contacto.concepto == 2"
									      v-model="folios.valor9"
									      row
									      dense
									      readonly
									      hide-details
									      class="mt-0 mb-4"
									    >
									      <v-radio
									        label="SI"
									        :value="1"
									      ></v-radio>
									      <v-radio
									        label="NO"
									        :value="2"
									      ></v-radio>
									    </v-radio-group>

											<label v-if="contacto.concepto == 2">¿El asesor se dijere de manera formal y educada con el alumno?</label>
									    <v-radio-group
												v-if="contacto.concepto == 2"
									      v-model="folios.valor10"
									      row
									      dense
									      readonly
									      hide-details
									      class="mt-0 mb-4"
									    >
									      <v-radio
									        label="SI"
									        :value="1"
									      ></v-radio>
									      <v-radio
									        label="NO"
									        :value="2"
									      ></v-radio>
									    </v-radio-group>

											<v-textarea
												v-model="folios.retroalimentacion"
												:rows="6"
												auto-grow
												filled
												dense
												readonly
												label="Escribe una Retroalimentación"
											>
											</v-textarea>

                      <v-divider class="my-2" v-if="folios"></v-divider>

                      <div v-if="folios">
                        <div class="font-weight-medium">Audio del chat seleccionado</div>
                        <div v-if="folios.audio_numero">
                          Audio #{{ folios.audio_numero }}
                        </div>
                        <div v-else class="grey--text text--darken-1">
                          Sin audio seleccionado.
                        </div>

                        <div v-if="folios.audio_url" class="mt-2">
                          <audio
                            :src="folios.audio_url"
                            controls
                            style="width: 100%;"
                          ></audio>
                        </div>

                        <v-textarea
                          v-if="folios.audio_comentario"
                          v-model="folios.audio_comentario"
                          :rows="3"
                          auto-grow
                          filled
                          dense
                          class="mt-2"
                          label="Comentario del audio"
                          readonly
                        >
                        </v-textarea>
                      </div>
										</v-col>
							    </v-row>
							  </v-card-text>
							</v-card>
						</v-col>

          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="black"
            tile
            dark
            small
            @click="close"
          >
            <v-icon small left>mdi-cancel</v-icon>
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>

          <v-btn
            color="red"
            tile
            dark
            small
            @click="dialogRechazo = true"
            v-if="getdatosUsuarioERPERP.iderp == 568"
          >
            <v-icon small left>mdi-close</v-icon>
            Rechazar
          </v-btn>

          <v-btn
            color="green"
            tile
            dark
            small
            @click="validar( )"
            v-if="getdatosUsuarioERPERP.iderp == 568"
          >
            <v-icon small left>mdi-check</v-icon>
            Validar
          </v-btn>


        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Subir audio manual -->
    <v-dialog v-model="dialogAudio" max-width="500px" persistent>
      <v-card>
        <v-card-title class="text-subtitle-1">
          Subir audio de seguimiento
          <v-spacer></v-spacer>
          <v-btn icon small @click="dialogAudio = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <v-file-input
            v-model="audioFile"
            accept="audio/*"
            label="Seleccionar archivo de audio"
            filled
            dense
            prepend-icon="mdi-microphone"
            @change="previsualizarAudio"
            :loading="audioCargando"
            :disabled="audioCargando"
          ></v-file-input>

          <div v-if="audioPreviewUrl" class="mt-4">
            <p class="text-caption mb-1">Vista previa del audio:</p>
            <audio :src="audioPreviewUrl" controls style="width: 100%"></audio>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="black"
            text
            small
            @click="dialogAudio = false"
            :disabled="audioCargando"
          >Cancelar</v-btn>
          <v-btn
            color="primary"
            small
            tile
            @click="enviarAudio"
            :loading="audioCargando"
            :disabled="!audioFile || audioCargando"
          >
            <v-icon left small>mdi-upload</v-icon>
            Subir audio
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Ver evidencias -->
    <v-dialog v-model="dialogImagen" max-width="1000px">
      <v-card class="elevation-0">
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn fab small text @click="dialogImagen = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <v-img
            :src=" url + imagen"
            contain
            max-height="80vh"
          >
          </v-img>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialogo para eliminar -->
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
      	<v-card-text>
	      	<v-row justify="space-around">
	      		<v-col cols="6">
	      			<v-card class="elevation-0" height="100%" style="display: table;">
		      			<div class="text-subtitle-1" style="display: table-cell; vertical-align: middle;">
		      				<strong>Eliminar</strong> ¿Estás seguro que deseas eliminar la información?
			      			<v-card-actions class="pt-6">
			      				<!-- Cerrar dialogo de confirmación y abrir el dialogo de editar la clase -->
			      			  <v-btn color="error" text  class="mr-2" @click="closeDelete()">No, cancelar</v-btn>
			      			  <!-- Guardar la información  -->
			      			  <v-btn color="#5C5C5C"  dark class="elevation-6"  @click="deleteItemConfirm()">Si</v-btn>
			      			</v-card-actions>
		      			</div>
	      			</v-card>
	      		</v-col>
	      		<v-col cols="5">
	      			<v-img src="@/assets/borrar.png"></v-img>
	      		</v-col>
		      </v-row>
      	</v-card-text>
      </v-card>
    </v-dialog>


    <!-- Dialogo para eliminar -->
    <v-dialog v-model="dialogRechazo" max-width="500px">
      <v-card>
      	<v-card-title primary-title>
      	  Mensaje de rechazo
      	</v-card-title>
      	<v-card-text>
      	  <v-textarea
      	  	:rows="3"
      	  	auto-grow
      	  	label="Escribe el mensaje de rechazo"
      	  	v-model="mensaje_rechazo"
      	  >
      	  </v-textarea>
      	</v-card-text>
      	<v-card-actions class="pt-6">
  				<!-- Cerrar dialogo de confirmación y abrir el dialogo de editar la clase -->
  			  <v-btn color="error" text  class="mr-2" @click="dialogRechazo = false">No, cancelar</v-btn>
  			  <!-- Guardar la información  -->
  			  <v-btn color="#5C5C5C"  dark class="elevation-6"  @click="rechazar()">Si</v-btn>
  			</v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

	</v-container>
</template>
<script>
import axios from 'axios';
	import { mapGetters } from 'vuex'
	// Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'
  import funcionesExcel        from '@/mixins/funcionesExcel'
  import leerImagenes          from '@/mixins/leerImagenes'

  import { Clipboard } from "@capacitor/clipboard";

  export default {

    mixins: [ validarErrores, funcionesExcel, leerImagenes ],

  	components:{
      Alerta,
      carga,
    },

    data: () => ({
    	// Alertas
    	parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      dialog: false,
      dialogDelete: false,

      editedIndex: -1,

      editedItem: {
        idretroalimentacion:0,
        p1:null,
        p2: null,
        p3:null,
        file: null,
        url:null,
				id_plantel:'',
				iniciales:'',
				calle:'',
				numero:0,
				colonia:'',
				estado:'',
				cp:0,
				telefono:'',
				link_maps:'',
				fecha_alta:null,
				activo_sn:0,
				fecha_baja:null,
				id_usuario_ultimo_cambio:0,
				fecha_ultimo_cambio:null,
        capacidad:0,
        link_zoom:'',
        tel_principal:'',
        tel_secundario:'',
        wpp_ventas:'',
        wpp_sucursal:'',
      },

      defaultItem: {
        idretroalimentacion:0,
        p1:null,
        p2: null,
        p3:null,
        file: null,
        url:null,
				id_plantel:'',
				iniciales:'',
				calle:'',
				numero:0,
				colonia:'',
				estado:'',
				cp:0,
				telefono:'',
				link_maps:'',
				fecha_alta:null,
				activo_sn:0,
				fecha_baja:null,
				id_usuario_ultimo_cambio:0,
				fecha_ultimo_cambio:null,
        capacidad:0,
        link_zoom:'',
        tel_principal:'',
        tel_secundario:'',
        wpp_ventas:'',
        wpp_sucursal:'',
      },

      // Filtros:
      incio:null,
			fin:null,

      // tabla
			search:'',
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      retros: [],
      headers: [
        { text: 'ID'        , value: 'idretroalimentacion' },
        { text: 'Evalua'    , value: 'evalua'              },
        { text: 'Evaluado'  , value: 'evaluado'            },
        { text: 'Plantel'  , value: 'plantel'            },
        { text: 'Promedio'  , value: 'promedioTexto'       },
        { text: 'Concepto'  , value: 'concepto'            },
        { text: 'Estatus'   , value: 'estatus'             },
        { text: 'Actions'   , value: 'actions', sortable: false },
      ],

      headersReporte: [
        { text: 'Escuela' , value: 'escuela' },
        { text: 'RI'      , value: 'ri'      },
        { text: 'NI'      , value: 'ni'      },
      ],

      ciclos:[],

      usuarios:[],

      editProspecto:{
      	idprospectos: 0,
      	folio: '',
      	telefono: '',
      	foto:'',
      	calificacion: 0,
      	valor1:null,
      	valor2:null,
      	valor3:null,
      	valor4:null,
      	valor5:null,
      	valor6:null,
      	valor7:null,
      	valor8:null,
      	valor9:null,
      	valor10:null,
      },

      contactos: [],
    	prospectos:[],
    	cantidadContactos: 0,
    	file: '',
      dragging: false,
      vistaPrevia: null,
      contacto:{},
      url: null,
      imagen: null,
			dialogImagen: false,

      // Audios por contacto (Twilio)
      dialogAudios: {
        estatus: false,
        index: null
      },
      urlWhatsApp: 'https://testfast.club/imagenes-whatsapp/',
      urlWhatsApp2: 'https://escuelakpi.club/imagenes-whatsapp/',
      twiliosByCities: {
        cdmx: 'whatsapp:+5215545703336',
        mty: 'whatsapp:+5218187047279',
        gdl: 'whatsapp:+5213316971156'
      },

			concepto: 3,
			estatus: 3,

			fechaini:(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      fechafin:(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),

      ciclo: null,
      dialogEdit: false,

      evaluados: [],
      evaluado: null,
      planteles: [],
      plantel: null,
      alumnos:[],
      alumno: null,

      acceso: false,
      dialogRechazo: false,
      mensaje_rechazo: '',
	  folios: null,

      // Carga de audio manual
      dialogAudio: false,
      audioFile: null,
      audioPreviewUrl: null,
      audioCargando: false,
    }),

    computed: {
    	...mapGetters('login',['getdatosUsuarioERPERP']),
      formTitle () {
        return this.editedIndex === -1 ? 'Agregar retroalimentación' : 'Editar retroalimentación'
      },

      puedeEditarContactos () {
        if (!this.editedItem.concepto) return false
        // NI: debe haber usuario seleccionado
        if (this.editedItem.concepto === 1) {
          return !!this.editedItem.id_usuario
        }
        // RI: debe haber plantel seleccionado
        if (this.editedItem.concepto === 2) {
          return !!this.editedItem.id_plantel
        }
        return false
      },

      filterRetros( ){

      	let retros = this.retros

      	if( this.concepto != 3 ){  retros = retros.filter( el => el.concepto == this.concepto ) }
      	if( this.estatus != 3 ){  retros = retros.filter( el => el.estatus == this.estatus ) }
      	if( this.evaluado ){  retros = retros.filter( el => el.id_evaluado == this.evaluado ) }
      	return retros

      },


      reporte( ){

      	let data = [

      		{
      			escuela: 'INBI',
      			ni: ((this.filterRetros.filter( el => el.escuela == 1 && el.concepto == 1 ).map(item => parseFloat( item.promedio )).reduce((prev, curr) => prev + curr, 0) / this.filterRetros.filter( el => el.escuela == 1 && el.concepto == 1 ).length )).toFixed( 1 ),
      			ri: ((this.filterRetros.filter( el => el.escuela == 1 && el.concepto == 2 ).map(item => parseFloat( item.promedio )).reduce((prev, curr) => prev + curr, 0) / this.filterRetros.filter( el => el.escuela == 1 && el.concepto == 2 ).length )).toFixed( 1 )
      		},

      		{
      			escuela: 'FAST',
      			ni: ((this.filterRetros.filter( el => el.escuela == 2 && el.concepto == 1 ).map(item => parseFloat( item.promedio )).reduce((prev, curr) => prev + curr, 0) / this.filterRetros.filter( el => el.escuela == 2 && el.concepto == 1 ).length )).toFixed( 1 ),
      			ri: ((this.filterRetros.filter( el => el.escuela == 2 && el.concepto == 2 ).map(item => parseFloat( item.promedio )).reduce((prev, curr) => prev + curr, 0) / this.filterRetros.filter( el => el.escuela == 2 && el.concepto == 2 ).length )).toFixed( 1 )
      		}

      	]



      	return data
      }
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },

      ciclo( value ){
      	console.log( value )
      	this.fechafin = value ? value.fecha_fin_ciclo.substr( 0,10) : this.fechafin
      	this.fechaini = value ? value.fecha_inicio_ciclo.substr( 0,10) : this.fechaini

      	if( value ){
      		this.initialize( )
      	}
      },

      // Cuando cambie el usuario a evaluar, actualizar la lista de prospectos
      'editedItem.id_usuario'(value) {
        if (this.editedItem.concepto === 1) {
          this.getProspectos()
          // Limpiar prospectos seleccionados en contactos si ya no pertenecen al usuario
          this.contactos = this.contactos.map(c => ({
            ...c,
            idprospectos: 0,
            folio: '',
            telefono: null
          }))
        }
      }

    },

    async created () {
    	this.url = axios.defaults.baseURL  + 'imagenes-retro/'
      await this.getAcceso()
      await this.initialize()
      await this.getCiclosActivos( )
      await this.getAlumnos( )
      await this.getUsuarios()
      await this.getProspectos( )
      await this.getPlanteles()

      this.contactos = [
      	{
        	idprospectos: 0,
	      	folio: '',
	      	foto:'',
	      	retroalimentacion:null,
					folio:null,
					telefono:null,
					valor1:null,
					valor2:null,
					valor3:null,
					valor4:null,
					valor5:null,
					valor6:null,
					valor7:null,
					valor8:null,
					valor9:null,
					valor10:null,
					file:null,
					url:null,
          audio_id: null,
          audio_numero: null,
          audio_url: null,
          audio_comentario: '',
          audios_disponibles: []
        },
        {
        	idprospectos: 0,
	      	folio: '',
	      	foto:'',
	      	retroalimentacion:null,
					folio:null,
					telefono:null,
					valor1:null,
					valor2:null,
					valor3:null,
					valor4:null,
					valor5:null,
					valor6:null,
					valor7:null,
					valor8:null,
					valor9:null,
					valor10:null,
					file:null,
					url:null,
          audio_id: null,
          audio_numero: null,
          audio_url: null,
          audio_comentario: '',
          audios_disponibles: []
        },
        {
        	idprospectos: 0,
	      	folio: '',
	      	foto:'',
	      	retroalimentacion:null,
					folio:null,
					telefono:null,
					valor1:null,
					valor2:null,
					valor3:null,
					valor4:null,
					valor5:null,
					valor6:null,
					valor7:null,
					valor8:null,
					valor9:null,
					valor10:null,
					file:null,
					url:null,
          audio_id: null,
          audio_numero: null,
          audio_url: null,
          audio_comentario: '',
          audios_disponibles: []
        }
      ]
    },

    methods: {

    	getAcceso() {
      	this.cargar = true
        this.retros = []

        if([ 2354, 626 , 2574].includes( this.getdatosUsuarioERPERP.iderp )) {

          this.acceso = true
          this.cargar = false
          return
        }

        return this.$http.get('retroalimentacion.acceso.alta/' + this.getdatosUsuarioERPERP.iderp ).then(response=>{
          console.log( response.data )
        	this.acceso = response.data.acceso
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      initialize () {
      	this.cargar = true
        this.retros = []

        const payload = {
        	fechafin  : this.fechafin,
					fechaini  : this.fechaini,
					id_usuario: 334
        }

        return this.$http.post('retroalimentacion.personal.all', payload ).then(response=>{

          this.retros = response.data
          console.log( this.retros )

        	this.evaluados = this.retros.reduce((acumulador, actual) => {
					  // Verifica si el id_evaluado ya existe en el acumulador
					  if (!acumulador.some(item => item.id_evaluado === actual.id_evaluado )) {
					    acumulador.push(actual);
					  }
					  return acumulador;
					}, []);

        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      getUsuarios( ){
      	this.usuarios = []
    		this.$http.get('usuarios.all.erp').then(response=>{

    			for(const i in response.data){

    				const { datos_completos } = response.data[i]

    				response.data[i].datos_completos = datos_completos.toUpperCase()
    			}

    			this.usuarios = response.data.filter( el => [ 18, 73, 78, 11, 31, 19 ].includes( el.idpuesto ) )

    		}).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      getProspectos( ){
    		this.cargar    = true
      	this.prospectos = []

        return this.$http.get('inscripciones.prospectos').then(response=>{
        	// Solo prospectos activos (finalizo == 0)
          // y, si ya se seleccionó un usuario a evaluar (concepto NI),
          // solo los que estén asignados a ese usuario.
          let arr = response.data.filter( el => el.finalizo == 0 )

          if (this.editedItem.concepto === 1 && this.editedItem.id_usuario) {
            arr = arr.filter(el => el.usuario_asignado == this.editedItem.id_usuario)
          }

        	this.prospectos = arr
        	this.cargar = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
    	},

    	getAlumnos( ){
    		this.cargar    = true
      	this.alumnos = []
        return this.$http.get('inscripciones.alumnos').then(response=>{
        	this.cargar = false
        	this.alumnos = response.data
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
    	},

      getPlanteles(){
        // planteles.all
        this.cargar    = true
      	this.planteles = []
        this.$http.get('planteles.all')
  .then(response => {
    this.cargar = false
    this.planteles = response.data.map(p => {
      return {
        ...p,
        id_plantel: p.idplantel
      }
    })
  })
  .catch(error => {
    this.validarError(error.response.data.message)
  })
  .finally(() => {
    this.cargar = false
    console.log( this.planteles)
  })
      },

    	getCiclosActivos(){
        this.ciclos = []
        this.$http.get('kpi.ciclos.all').then(response=>{
          this.ciclos = response.data
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      editItem (item) {
        this.editedIndex = this.retros.indexOf(item)
        this.contacto    = Object.assign({}, item)
        this.dialogEdit = true
      },

      deleteItem (item) {
        this.editedIndex = this.retros.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {

      	const payload = {
          idretroalimentacion: this.editedItem.idretroalimentacion,
          mensaje_rechazo: this.editedItem.mensaje_rechazo,
          estatus: this.editedItem.estatus,
          deleted: 1,
          // Mantener el valor actual de validado para evitar null en BD
          validado: typeof this.editedItem.validado !== 'undefined' && this.editedItem.validado !== null
            ? this.editedItem.validado
            : 1
        }

        this.$http.post('retroalimentacion.update', payload ).then(response=>{
          this.cargar = true
        	this.closeDelete()
        	this.initialize()
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })

      },


      rechazar () {

      	const payload = {
          idretroalimentacion: this.contacto.idretroalimentacion,
          mensaje_rechazo: this.mensaje_rechazo,
          validado: 0,
          estatus: 2,
          deleted: 0
        }

        this.$http.post('retroalimentacion.update', payload ).then(response=>{
          this.cargar = true
          this.dialogEdit = false
          this.dialogRechazo = false
        	this.closeDelete()
        	this.initialize()
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })

      },

      validar () {

      	const payload = {
          idretroalimentacion: this.contacto.idretroalimentacion,
          mensaje_rechazo: this.contacto.mensaje_rechazo,
          validado: 1,
          estatus: this.contacto.estatus,
          deleted: 0
        }


        this.$http.post('retroalimentacion.update', payload ).then(response=>{
          this.cargar = true
          this.dialogEdit = false
          this.dialogRechazo = false
        	this.closeDelete()
        	this.initialize()
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })

      },

      close () {
        this.dialog = false
        this.dialogEdit = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      updateFoto( contacto ){

      	// Verificar que el archivo existe
				if (!contacto.file) {
			    this.validarErrorDirecto("No se ha seleccionado un archivo.");
			    return;
				}

      	// Crear una instancia de FormData
		    let formData = new FormData();
		    formData.append('file', contacto.file);

        // Crear vista previa utilizando FileReader
		    const reader = new FileReader();
		    reader.readAsDataURL(contacto.file); // Acceder correctamente al archivo desde contacto.file

        reader.onload = () => {
          contacto.url = reader.result
          contacto.formData = formData
          contacto.image_name = contacto.file.name
        };
      },

      updateFoto2( ){

      	// Verificar que el archivo existe
				if (!this.editedItem.file) {
			    this.validarErrorDirecto("No se ha seleccionado un archivo.");
			    return;
				}

      	// Crear una instancia de FormData
		    let formData = new FormData();
		    formData.append('file', this.editedItem.file);

        // Crear vista previa utilizando FileReader
		    const reader = new FileReader();
		    reader.readAsDataURL(this.editedItem.file); // Acceder correctamente al archivo desde this.editedItem.file

        reader.onload = () => {
          this.editedItem.url = reader.result
          this.editedItem.formData = formData
          this.editedItem.image_name = this.editedItem.file.name
        };


      },

      addCantidad () {

      	if( this.cantidadContactos < 5 ){
	        this.cantidadContactos += 1
	        this.contactos.push({
	        	idprospectos: 0,
		      	folio: '',
		      	telefono: '',
		      	foto:'',
		      	retroalimentacion:null,
						folio:null,
						telefono:null,
						valor1:null,
						valor2:null,
						valor3:null,
						valor4:null,
						valor5:null,
						valor6:null,
						valor7:null,
						valor8:null,
						valor9:null,
						valor10:null,
						id_alumno: null,
	        })
      	}
      },

      menosCantidad () {
        if( this.cantidadContactos > 1 ){
        	this.cantidadContactos -= 1
        	this.contactos.pop()
        }
      },

      limpiarAudioContacto (contacto) {
        contacto.audio_id = null
        contacto.audio_numero = null
        contacto.audio_url = null
        contacto.audio_comentario = ''
      },

      onCambioProspecto (contacto) {
        // Si se cambia de prospecto, limpiar siempre la referencia al audio
        this.limpiarAudioContacto(contacto)
      },

	  subirAudio (contacto, index) {
		this.contacto = contacto
        this.audioFile = null
        this.audioPreviewUrl = null
		this.dialogAudio = true
	  },

      previsualizarAudio () {
        if (!this.audioFile) {
          this.audioPreviewUrl = null
          return
        }
        this.audioPreviewUrl = URL.createObjectURL(this.audioFile)
      },

      async enviarAudio () {
        if (!this.audioFile) {
          this.validarErrorDirecto('Por favor selecciona un archivo de audio.')
          return
        }

        this.audioCargando = true
        let formData = new FormData()
        formData.append('file', this.audioFile)

        try {
          const response = await this.$http.post('retroalimentacion.upload.audio', formData)
          
          if (response.data && response.data.audio_url) {
            const audioUrl = response.data.audio_url
            
            // Actualizar el contacto seleccionado con la nueva URL
            // Usamos la base URL de imágenes que ya tiene el componente
            this.$set(this.contacto, 'audio_url', this.url + audioUrl)
            this.$set(this.contacto, 'audio_id', 'manual_' + Date.now())
            this.$set(this.contacto, 'audio_numero', 'Subido')

            this.dialogAudio = false
            this.audioFile = null
            this.audioPreviewUrl = null
            
            this.parametros = {
              dialogError: true,
              mensaje: 'Audio subido correctamente.',
              color: 'green'
            }
            this.respuestaAlerta = true
          } else {
            throw new Error('No se recibió la URL del audio')
          }

        } catch (error) {
          this.validarError(error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : 'Error al subir el audio.')
        } finally {
          this.audioCargando = false
        }
      },

      async abrirSelectorAudio (contacto, index) {

        if (this.editedItem.concepto === 1 && !contacto.idprospectos) {
          this.validarErrorDirecto('Primero selecciona un prospecto.')
          return
        }

        if (this.editedItem.concepto === 2 && !contacto.id_alumno) {
          this.validarErrorDirecto('Primero selecciona un alumno.')
          return
        }

        this.cargar = true

        try {
          let telefono = null
          let escuela = 1

          if (this.editedItem.concepto === 1) {
            const prospecto = this.prospectos.find(p => p.idprospectos == contacto.idprospectos)
            if (!prospecto) {
              this.validarErrorDirecto('No se encontró el prospecto seleccionado.')
              this.cargar = false
              return
            }
            telefono = prospecto.telefono
            escuela = prospecto.escuela || 1
          } else {
            const alumno = this.alumnos.find(a => a.id_alumno == contacto.id_alumno)
            if (!alumno) {
              this.validarErrorDirecto('No se encontró el alumno seleccionado.')
              this.cargar = false
              return
            }
            telefono = alumno.telefono || alumno.celular
            escuela = alumno.escuela || 1
          }

          if (!telefono) {
            this.validarErrorDirecto('El contacto no tiene teléfono registrado.')
            this.cargar = false
            return
          }

          // Normalizar teléfono a últimos 10 dígitos
          let tel = String(telefono).replace(/\D/g, '')
          if (tel.length > 10) {
            tel = tel.slice(-10)
          }

          const usuario = 'whatsapp:+521' + tel

          const payload = {
            usuario,
            modo: 1,
            escuela
          }

          const response = await this.$http.post('twilio.chats.unico', payload)
          const mensajes = response.data && response.data.conversacionCompleta
            ? response.data.conversacionCompleta
            : []

          // Solo considerar audios de las últimas 2 semanas
          const limiteDias = 14
          const ahora = new Date()
          const limiteFecha = new Date(ahora.getTime() - limiteDias * 24 * 60 * 60 * 1000)

          const audios = mensajes
            .filter(m => {
              if (m.type !== 3) return false
              if (!m.fecha_creacion) return true // si no viene fecha, no filtramos
              const f = new Date(m.fecha_creacion)
              return !isNaN(f.getTime()) && f >= limiteFecha
            })
            // Ordenar primero por fecha descendente (más recientes al inicio)
            .sort((a, b) => {
              const fa = new Date(a.fecha_creacion || 0).getTime()
              const fb = new Date(b.fecha_creacion || 0).getTime()
              return fb - fa
            })
            .map((m, i) => ({
              id: m.sid || m.id || i,
              numero: i + 1,
              fecha: m.fecha_creacion,
              mio: m.mio,
              url: m.mio == 0
                ? this.urlWhatsApp + m.MediaUrl0
                : this.urlWhatsApp2 + m.MediaUrl0
            }))

          this.$set(this.contactos[index], 'audios_disponibles', audios)

          this.dialogAudios.estatus = true
          this.dialogAudios.index = index

        } catch (error) {
          this.validarError(error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : 'No se pudieron obtener los audios del chat.')
        } finally {
          this.cargar = false
        }
      },

      seleccionarAudio (audio) {
        if (this.dialogAudios.index === null) {
          this.dialogAudios.estatus = false
          return
        }

        const contacto = this.contactos[this.dialogAudios.index]
        contacto.audio_id = audio.id
        contacto.audio_numero = audio.numero
        contacto.audio_url = audio.url

        this.dialogAudios.estatus = false
      },

      async confirmarQuitarAudio (contacto) {
        if (!contacto.audio_url) return

        try {
          const result = await this.$swal({
            title: 'Quitar audio seleccionado',
            text: 'Si quitas el audio, también se borrará el comentario asociado. ¿Deseas continuar?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, quitar audio',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#d33',
          })

          if (result.isConfirmed) {
            this.limpiarAudioContacto(contacto)
          }
        } catch (e) {
          // Si algo falla con SweetAlert2, no hacemos nada adicional
        }
      },

      save () {

      	for( const i in this.contactos ){

      		const { idprospectos, telefono } = this.contactos[i]

      		const existeContacto = this.prospectos.find( el => el.idprospectos == idprospectos )

      		this.contactos[i]['folio']    = existeContacto ? existeContacto.folio : ''
      		this.contactos[i]['telefono'] = existeContacto ? existeContacto.telefono : telefono

      	}

      	const existeUsuario = this.usuarios.find( el => el.id_usuario == this.editedItem.id_usuario )

      	const payload = {
      		id_evalua    : this.getdatosUsuarioERPERP.iderp,
      		id_evaluado  : this.editedItem.concepto === 1 ? this.editedItem.id_usuario : null,
      		id_plantel  : this.editedItem.concepto === 2 ? this.editedItem.id_plantel : null,
      		concepto     : this.editedItem.concepto,

      		p1           : this.editedItem.p1,
					p2           : this.editedItem.p2,
					p3           : this.editedItem.p3,
					calificacion : this.editedItem.calificacion,

      		contactos    : this.contactos,
      		escuela      : existeUsuario ? existeUsuario.escuela : 0,
      		validado     : this.getdatosUsuarioERPERP.iderp == 1258 ? 0 : 1
      	}



      	let formData = new FormData();

      	let validado = this.getdatosUsuarioERPERP.iderp == 1258 ? 0 : 1

      	// Agregar datos principales al FormData
				formData.append("id_evalua"      , payload.id_evalua);
				formData.append("id_evaluado"    , payload.id_evaluado);
				formData.append("id_plantel"    , payload.id_plantel);
				formData.append("concepto"       , payload.concepto);
				formData.append("escuela"        , payload.escuela);
				formData.append("p1"             , payload.p1);
				formData.append("p2"             , payload.p2);
				formData.append("p3"             , payload.p3);
				formData.append("calificacion"   , payload.calificacion);
    		formData.append("imagenAdicional", this.editedItem.file);
    		formData.append("validado"       , validado );

				// Agregar los contactos al FormData
				payload.contactos.forEach((contacto, index) => {
			    // Agregar la información del contacto
			    formData.append(`contactos[${index}]`, JSON.stringify({
		        calificacion     : contacto.calificacion,
		        idprospectos     : contacto.idprospectos,
		        retroalimentacion: contacto.retroalimentacion,
		        folio            : contacto.folio,
		        telefono         : contacto.telefono,
		        valor1           : contacto.valor1 ? contacto.valor1 : 0,
		        valor2           : contacto.valor2 ? contacto.valor2 : 0,
		        valor3           : contacto.valor3 ? contacto.valor3 : 0,
		        valor4           : contacto.valor4 ? contacto.valor4 : 0,
		        valor5           : contacto.valor5 ? contacto.valor5 : 0,
		        valor6           : contacto.valor6 ? contacto.valor6 : 0,
		        valor7           : contacto.valor7 ? contacto.valor7 : 0,
		        valor8           : contacto.valor8 ? contacto.valor8 : 0,
		        valor9           : contacto.valor9 ? contacto.valor9 : 0,
		        valor10          : contacto.valor10 ? contacto.valor10 : 0,
		        id_alumno        : contacto.id_alumno ? contacto.id_alumno : 0,
            audio_id         : contacto.audio_id ? contacto.audio_id : null,
            audio_numero     : contacto.audio_numero ? contacto.audio_numero : null,
            audio_url        : contacto.audio_url ? contacto.audio_url : '',
            audio_comentario : contacto.audio_comentario ? contacto.audio_comentario : '',
			    }));

			    // Agregar el archivo si existe
			    if (contacto.file) {
		        formData.append(`contactos[${index}][file]`, contacto.file);
			    }
				});

        this.$http.post('retroalimentacion.personal', formData ).then(response=>{
        	this.contactos = [
		      	{
		        	idprospectos: 0,
			      	folio: '',
			      	foto:'',
			      	retroalimentacion:null,
							folio:null,
							telefono:null,
							valor1:null,
							valor2:null,
							valor3:null,
							valor4:null,
							valor5:null,
							valor6:null,
							valor7:null,
							valor8:null,
							valor9:null,
							valor10:null,
							file:null,
							url:null,
          audio_id: null,
          audio_numero: null,
          audio_url: null,
          audio_comentario: '',
          audios_disponibles: []
        },
		        {
		        	idprospectos: 0,
			      	folio: '',
			      	foto:'',
			      	retroalimentacion:null,
							folio:null,
							telefono:null,
							valor1:null,
							valor2:null,
							valor3:null,
							valor4:null,
							valor5:null,
							valor6:null,
							valor7:null,
							valor8:null,
							valor9:null,
							valor10:null,
							file:null,
							url:null,
          audio_id: null,
          audio_numero: null,
          audio_url: null,
          audio_comentario: '',
          audios_disponibles: []
        },
		        {
		        	idprospectos: 0,
			      	folio: '',
			      	foto:'',
			      	retroalimentacion:null,
							folio:null,
							telefono:null,
							valor1:null,
							valor2:null,
							valor3:null,
							valor4:null,
							valor5:null,
							valor6:null,
							valor7:null,
							valor8:null,
							valor9:null,
							valor10:null,
							file:null,
							url:null,
          audio_id: null,
          audio_numero: null,
          audio_url: null,
          audio_comentario: '',
          audios_disponibles: []
        }
		      ]
        	this.cantidadContactos = 0
        	this.initialize()
        	this.cargar = false
      		this.close()
        }).catch( error =>{
        	this.validarError( error.response.data.message )
      	}).finally( () => { this.cargar = false })


        // }
      },

      async pegar(event) {
        if (event.code == "KeyV") {
          const { type, value } = await Clipboard.read();

                    // Validamos que sea de tipo imagen
          if (type == "image/png") {
                    // Convertimos el base64 en una imagen
            const file = this.convertFile(value, "imagen.png");
            this.createFile(file);
          }
        }
      },

      convertFile(dataurl, filename) {
        var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);

        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }

        return new File([u8arr], filename, { type: mime });
      },

      createFile(file) {
        if (file.size > 10000000) {
          alert("please check file size no over 5 MB.");
          return;
        }

        console.log( 'archivooooo',file )

        if( !this.editedItem.file ){

        	this.editedItem.file = file
        	this.updateFoto2( )

        }else if( !this.contactos[0].file ){
        	this.contactos[0].file = file
        	this.updateFoto( this.contactos[0] )
        }else if( !this.contactos[1].file ){
        	this.contactos[1].file = file
        	this.updateFoto( this.contactos[1] )
        }else if( !this.contactos[2].file ){
        	this.contactos[2].file = file
        	this.updateFoto( this.contactos[2] )
        }


      },

      verImagen( imagen ){
        this.imagen       = imagen
        this.dialogImagen = true
      },
    },
  }
</script>


<style scoped>
  .dropZone {
    width: 80%;
    height: 150px;
    position: relative;
    border: 2px dashed #eee;
  }

  .dropZone:hover {
    border: 2px solid #D8D8D8;
  }

  .dropZone:hover .dropZone-title {
    color: #1975A0;
  }

  .dropZone-info {
    color: #A8A8A8;
    position: absolute;
    top: 50%;
    width: 100%;
    transform: translate(0, -50%);
    text-align: center;
  }

  ..dropZone-title {
    color: #787878;
  }

  .dropZone input {
    position: absolute;
    cursor: pointer;
    top: 0px;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
  }

  .dropZone-upload-limit-info {
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
  }

  .dropZone-over {
    background: #D8D8D8;
    opacity: 0.8;
  }

  .dropZone-uploaded {
    width: 80%;
    height: 200px;
    position: relative;
    border: 2px dashed #eee;
  }

  .dropZone-uploaded-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #D8D8D8;
    position: absolute;
    top: 50%;
    width: 100%;
    transform: translate(0, -50%);
    text-align: center;
  }

  .removeFile {
    width: 200px;
  }
</style>
